import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { CartService } from '@services/cart/cart-services';

import { NAV_BAR_ITEMS } from '@constants/components.constants';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})

export class NavbarComponent {
  public isScrolled = false;
  public isMenuOpen = false;
  public readonly navItems = NAV_BAR_ITEMS;
  public cartService = inject(CartService);

  @HostListener('window:scroll', [])
  public onWindowScroll(): void {
    this.isScrolled = window.scrollY > 50;
  }

  public toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;

    if (this.isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      this.closeMenu();
    }
  }

  public closeMenu(): void {
    this.isMenuOpen = false;
    document.body.classList.remove('menu-open');
  }
}
